import { Button, TextField } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import * as React from 'react';
import ReduxLanguage from '../ReduxLanguage';
import { IAccessRequestFormDTO } from '../../repository/jago/model/input/IAccessRequestFormDTO';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    height: '100%',
    width: '90%',
    flex: 1,
  },
  inputTitle: {
    marginTop: 20,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
});

export interface IAccessRequestFormState {
  formData: IAccessRequestFormDTO;
  errors: Record<keyof IAccessRequestFormDTO, boolean>;
}

export interface IAccessRequestFormProps extends WithStyles<typeof styles> {
  onSubmitAccessRequest: (values: IAccessRequestFormDTO) => void;
}

class AccessRequestForm extends React.Component<IAccessRequestFormProps, IAccessRequestFormState> {

  constructor(props: IAccessRequestFormProps) {
    super(props);
    this.state = {
      formData: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
      },
      errors: {
        firstName: false,
        lastName: false,
        companyName: false,
        email: false,
      },
    };
  }

  isEmailValid(email?: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  onChangeValue(field: keyof IAccessRequestFormDTO, mandatory: boolean, value?: string) {
    const { formData, errors } = this.state;
    const isEmailField = field === 'email';
    const hasError = isEmailField
      ? !this.isEmailValid(value)
      : !value && mandatory;
    this.setState({
      errors: { ...errors, [field]: hasError },
      formData: { ...formData, [field]: value || '' },
    });
  }

  onSubmitForm() {
    const { formData } = this.state;
    if (!this.canSubmitForm()) {
      return;
    }
    const { onSubmitAccessRequest } = this.props;
    onSubmitAccessRequest(formData);
  }

  canSubmitForm() {
    const { formData } = this.state;
    return !_.isEmpty(formData.firstName)
      && !_.isEmpty(formData.lastName)
      && !_.isEmpty(formData.companyName)
      && this.isEmailValid(formData.email);
  }

  public render() {
    const { classes } = this.props;
    const { formData, errors } = this.state;
    const canSubmit = this.canSubmitForm();

    return (
      <div className={classes.container}>
        <TextField
          id="access-request-first-name"
          label={<ReduxLanguage languageKey="forms.firstName" />}
          variant="outlined"
          fullWidth
          required
          error={errors.firstName}
          value={formData.firstName}
          onChange={e => this.onChangeValue('firstName', true, e.target.value)}
        />
        <TextField
          id="access-request-last-name"
          label={<ReduxLanguage languageKey="forms.lastName" />}
          variant="outlined"
          fullWidth
          required
          error={errors.lastName}
          value={formData.lastName}
          style={{ marginTop: 20 }}
          onChange={e => this.onChangeValue('lastName', true, e.target.value)}
        />
        <TextField
          id="access-request-company-name"
          label={<ReduxLanguage languageKey="mks.companyName" />}
          variant="outlined"
          fullWidth
          required
          error={errors.companyName}
          value={formData.companyName}
          style={{ marginTop: 20 }}
          onChange={e => this.onChangeValue('companyName', true, e.target.value)}
        />
        <TextField
          id="access-request-email"
          label={<ReduxLanguage languageKey="forms.email" />}
          variant="outlined"
          fullWidth
          required
          error={errors.email}
          value={formData.email}
          style={{ marginTop: 20 }}
          onChange={e => this.onChangeValue('email', true, e.target.value)}
        />
        <div style={{ position: 'sticky', bottom: '0', paddingTop: '20px', backgroundColor: 'white', marginLeft: '-5px', marginRight: '-5px', zIndex: 1 }}>
          <Button
            variant="contained"
            disabled={!canSubmit}
            style={{ width: '100%', opacity: canSubmit ? 1 : 0.5, backgroundColor: '#5AC0B1', color: 'white', marginTop: 25, fontWeight: 'bold' }}
            onClick={() => this.onSubmitForm()}
          >
            <ReduxLanguage languageKey="forms.send" />
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(AccessRequestForm);
